"use strict";

var LoggerInstance = require("js-logger").get("LogoutActions");

var ActionsHelper = require("../actions/ActionsHelper");

var LogoutApi = require("../api/LogoutApi");

var WizardConstants = require("../constants/WizardConstants");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var BootstrapPrompt = require("../shared/BootstrapPrompt");

var LogoutStore = require("../stores/LogoutStore");

var LogoutActions = {
	initializeStore: function (options) {
		Dispatcher.dispatch({
			actionType: Constants.LOGOUT_INITIALIZE,
			options: options
		});
	},

	initializeLogout: function ($component, isDesignMode) {
		var logoutComponent = $component || $('[data-component="logout"]');
		if (logoutComponent.length) {
			logoutComponent.find("a").click((event) => {
				this.logout(event, isDesignMode);
			});
		}
	},

	logout: function (event, isDesignMode) {
		event = ActionsHelper.getEventOrReturn(event, isDesignMode, "Logout action called successfully", /* preventDefaultInDesignMode */ false);
		if (!event) {
			return;
		}

		LogoutApi.logout()
			.done(() => {
				// if there are any OPCO coupons stored, clear them out
				Object.keys(sessionStorage).forEach((key) => {
					if (key.indexOf("currentCoupon_") === 0) {
						sessionStorage.removeItem(key);
					}
				});
				window.location.reload(/* serverRefresh */ true);
			}).fail(err => {
				LoggerInstance.error(err);
				BootstrapPrompt.alert(LogoutStore.getWizardValue(
					WizardConstants.WIZARDS.LOGIN_MESSAGES,
					WizardConstants.LOGIN_MESSAGE_FIELDS.LOGOUT_ERROR
				));
			});
	}
};

module.exports = LogoutActions;
